import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { session } from 'services/session';

/* Shared components */
import NrtvRedirect from 'components/base/redirect';
import Editor from 'components/base/smartlinks/editor';

/* Admin components */
import AdminWelcome from 'components/admin/welcome';
import AdminDashboard from 'components/admin/dashboard/dashboard';
import SmartlinkEditor from 'components/admin/smartlinks/smartlink-editor';
import FeedComparison from 'components/admin/feeds/feed-comparison';
import AuctionConfig from 'components/admin/bid-center/auction-config';
import BulkMatch from 'components/admin/bid-center/bulk-match';
import { MerchOverview, MerchEdOverview, PubOverview } from './components/admin/bid-center/overview-extension';
import Collections from 'components/admin/collections/collections';
import CreateCollection from './components/admin/collections/create-collection';

/* Merchant components */
import MerchantArticleSearch from 'components/merchant/article-search/article-search';
import MerchantDashboard from 'components/merchant/dashboard/dashboard';
import {
	MerchArticleMegatable, MerchRecommendationMegatable,
} from 'components/merchant/megatable/megatable-extensions';
import MerchantStrategies from 'components/merchant/strategies/merchant-strategies';


/* Publisher components */
import PublisherDashboard from 'components/publisher/dashboard/dashboard';
import {
	ArticleMegatable, MerchantMegatable, ProductMegatable, SmartlinkMegatable,
} from 'components/publisher/megatable/megatable-extensions';
import Insights from 'components/publisher/trends/insights';
import RetailerOverview from 'components/publisher/rates/retailer-overview';
import RetailerProfile from 'components/publisher/rates/retailer-profile';
import StrategyProducts from 'components/publisher/rates/strategy-products';
import LinkCreation from 'components/creator/link-creation';

/* Static components */
import ChangePassword from 'components/base/authentication/change-password';
import NewLogin from 'components/base/authentication/new-login';
import PrivacyPolicy from 'components/base/authentication/privacy-policy';
import ForgotPassword from './components/base/authentication/forgot-password';
import ResetPassword from './components/base/authentication/reset-password';
import TermsConditions from './components/base/authentication/terms-conditions';

import ArticleSearch from './components/base/article-search';
import CampaignTracking from './components/merchant/campaign-tracking/campaign-tracking';

export default (props) => {
	return (
		<Switch>
			<Route exact path="/v2"
			       render={() => <NrtvRedirect {...props} />}
			/>

			{/* Admin routes */}
			<Route exact path="/v2/admin" component={ AdminWelcome } />
			<Route exact path="/v2/admin/dashboard"
			       component={ AdminDashboard }
			/>
			<Route exact path="/v2/admin/smartlinks/editor"
			       component={ Editor }
			/>
			<Route exact path="/v2/admin/smartlinks/:smartlinkId?/edit"
			       component={ SmartlinkEditor }
			/>
			<Route exact path="/v2/admin/feed-comparison"
			       component={ FeedComparison }
			/>
			<Route exact path="/v2/admin/feed-comparison/:merchantId?/"
			       component={ FeedComparison }
			/>
			<Route exact path="/v2/admin/feed-comparison/:merchantId?/:fieldName?/"
			       component={ FeedComparison }
			/>
			<Route exact path="/v2/admin/bid-center/auction-config-editor/"
			       component={ AuctionConfig }
			/>
			<Route exact path="/v2/admin/bid-center/bulk-match/"
			       component={ BulkMatch }
			/>
			<Route exact path="/v2/admin/bid-center/merchant-overview"
			       render={() => <MerchOverview {...props} />}
			/>
			<Route exact path="/v2/admin/bid-center/merch-ed-overview"
			       render={() => <MerchEdOverview {...props} />}
			/>
			<Route exact path="/v2/admin/bid-center/publisher-overview"
			       component={ PubOverview }
			/>
			<Route exact path="/v2/admin/collections"
				component={ Collections }
			/>
			<Route exact path="/v2/admin/collections/create-collection"
			       component={ CreateCollection }
			/>
			{/* Catch the rest of the admin pages to redirect to v1 */}
			<Route exact path="/v2/admin/*" component={ NrtvRedirect } />

			{/* Merchant routes */}
			<Route exact path="/v2/merchant/:merchantId?/article-search/:searchType?"
			       render={() => <MerchantArticleSearch {...props} />}
			/>
			<Route exact path="/v2/merchant/:merchantId?/desk"
			       render={() => <MerchantDashboard {...props} />}
			/>
			<Route exact path="/v2/merchant/:merchantId?/megatables/articles"
			       render={() => <MerchArticleMegatable {...props} />}
			/>
			<Route exact path="/v2/merchant/:merchantId?/megatables/recommendations"
			       render={() => <MerchRecommendationMegatable {...props} />}
			/>
			<Route exact path="/v2/merchant/:merchantId?/megatables/campaign-performance/:strategyId?"
				   render={() => <CampaignTracking {...props} />}
			/>
			<Route exact path="/v2/merchant/:merchantId?/campaigns/:action?"
			       render={() => <MerchantStrategies {...props} />}
			/>
			{/* Publisher routes */}
			{session.isAdminView
				? (
					<Redirect from="/v2/publisher/:publisherId?/new-recs/cart-explorer"
						to="/v2/publisher/:publisherId?/new-recs/product-research"
					/>
				) : (
					<Route exact path="/v2/publisher/:publisherId?/new-recs/cart-explorer"
						component={ Insights }
					/>
				)}
			<Route exact path="/v2/publisher/:publisherId?/new-recs/product-research"
			       component={ Insights }
			/>
			<Route exact path="/v2/publisher/:publisherId?/dashboard"
			       render={() => <PublisherDashboard {...props} />}
			/>
			<Route exact path="/v2/publisher/:publisherId?/megatables/articles"
			       render={() => <ArticleMegatable {...props} />}
			/>
			<Route exact path="/v2/publisher/:publisherId?/megatables/merchants"
			       render={() => <MerchantMegatable {...props} />}
			/>
			<Route exact path="/v2/publisher/:publisherId?/megatables/products"
			       render={() => <ProductMegatable {...props} />}
			/>
			<Route exact path="/v2/publisher/:publisherId?/megatables/smartlinks"
			       render={() => <SmartlinkMegatable {...props} />}
			/>
			<Route exact path="/v2/publisher/:publisherId?/new-recs/rates"
			       component={ RetailerOverview }
			/>
			<Route exact path="/v2/publisher/:publisherId?/new-recs/rates/:retailerId?"
			       component={ RetailerProfile }
			/>
			<Route exact path="/v2/publisher/:publisherId?/new-recs/rates/:retailerId?/strategies/:strategyId?"
			       component={ StrategyProducts }
			/>
			<Route exact path="/v2/publisher/:publisherId?/new-recs/search-trends"
			       component={ Insights }
			/>
			<Route exact path="/v2/publisher/:publisherId?/smartlinks/editor"
			       render={() => <Editor {...props} />}
			/>
			<Route exact path="/v2/publisher/:publisherId?/smartlinks/:smartlinkId?/edit"
			       component={ SmartlinkEditor }
			/>
			<Route exact path="/v2/publisher/terms-conditions"
			       render={() => !session.termsAccepted ? <TermsConditions {...props} /> : <Redirect to="/v2" />}
			/>
			{props.isMobile && (
				<Route exact path="/v2/publisher/:publisherId?/link-creation"
					render={() => <LinkCreation {...props} />}
				/>
			)}

			{/* Static routes */}
			<Route exact path="/v2/login" render={() => <NewLogin {...props} />} />
			<Route exact path="/v2/create-user"
			       render={() => <NewLogin {...props} newUser={true} />}
			/>
			{/* TODO: Deprecate /v2/change-password */}
			<Route exact path="/v2/change-password" component={ ChangePassword } />
			<Route exact path="/v2/privacy-policy" render={() => <PrivacyPolicy {...props} /> } />
			<Route exact path="/v2/reset-password-request"
			       render={() => <ForgotPassword {...props} />}
			/>
			<Route exact path="/v2/reset-password-completion"
			       render={() => <ResetPassword {...props} />}
			/>
			<Route exact path="/v2/article-search" render={() => <ArticleSearch {...props} /> } />

			<Route render={ () => <Redirect to="/v2" /> } />
		</Switch>
	);
};
